interface IErrorOccurredProps {
  message?: string
}

export function ErrorOccurred({ message = "Une erreur est survenue. Veuillez rééssayer plus tard" }: IErrorOccurredProps) {

  return (
    <>
      <p className="break-words">{message}</p>
    </>
  )
}